import { useRouteError } from 'react-router-dom';
import { Page404 } from '../layout/Page404';

export function ErrorBoundary() {
  const error = useRouteError();

  if (error && (error as { statusCode: number }).statusCode === 404) {
    return <Page404 />;
  }

  console.error('Unhandled error:', error);

  return (
    <div className="flex h-screen bg-background items-center justify-center">
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-4xl font-bold text-red-600">
          Something went wrong
        </h1>
        <p className="text-lg text-gray-600 mt-4">
          An unexpected error occurred. Please try again later.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Reload Page
        </button>
      </div>
    </div>
  );
}
